(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Aktiv søgning',
    noCollectionFound: 'Ingen kollektioner fundet',
    allProducts: 'Se alle produkter',
    matching: 'matchende',
    sortBy: 'Sorteret efter',
    relevance: 'Relevans',
    outOf: 'ud af',
    resultsFound: 'resultater fundet',
    oneResultFound: '1 resultat fundet',
    noResultFound: 'Ingen resultater fundet',
    addToCart: 'Læg i kurv',
    searchForProduct: 'Søg efter produkter',
    selectedFilter: 'Valgte filtre',
    clearAll: 'Ryd alle',
    noPageFound: 'Ingen side fundet',
    noArticleFound: 'Ingen indlæg fundet',
    outOfStock: 'Udsolgt',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Ingen resultater for ' + render(text);
    },
    result_for: function(text, render) {
      return 'Mest relevante produkter for ' + render(text);
    },
    in: function() {
      return 'i ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Prøv ' +
        render(html_tags[0]) +
        ' at ryd dine filtre ' +
        render(html_tags[1]) +
        ' eller ' +
        render(html_tags[2]) +
        ' ændre din søgning ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' ud  af'
      );
    },

    by: function(text, render) {
      return 'af ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
